import {Button, Box, TextField, InputAdornment, Snackbar, Alert} from "@mui/material";
import React, {useState} from "react";
import {CopyTextToClipboard} from "../copy/CopyTextToClipboard";

function CopyContentToClipboard({label, copyText = "", showStartAdornment = false, startAdornmentText, compact = false, code = false}) {
    const renderInputStartAdornment = (showStartAdornment, startAdornmentText) => {
        if (showStartAdornment) {
            return (
                <InputAdornment position="start">{startAdornmentText}</InputAdornment>
            );
        }
    };
    const [open, setOpen] = useState(false)
    const handleCopy = () => {
        CopyTextToClipboard(copyText).then(() => {
            setOpen(true);
        });
    };
    return (
        <div>
            <Box display="flex" flexWrap="nowrap" alignItems={compact ? 'center' : undefined}>
                <Box flexGrow={1} sx={{minWidth: 0}}>
                    <TextField
                        type="text"
                        value={copyText || ""}
                        size="small"
                        variant="outlined"
                        margin={compact ? 'none' : 'dense'}
                        multiline={code}
                        minRows={code ? 3 : undefined}
                        maxRows={code ? 6 : undefined}
                        sx={code ? {'& .MuiOutlinedInput-input': {fontFamily: 'monospace', fontSize: 12, lineHeight: 1.7, overflowWrap: 'anywhere'}} : compact ? {'& .MuiOutlinedInput-root': {height: 30}, '& .MuiOutlinedInput-input': {py: 0.5, fontSize: 13}} : undefined}
                        label={label}
                        fullWidth
                        onClick={(e) => {
                            if (e.target.localName === "input" || e.target.localName === "textarea") {
                                return e?.target?.setSelectionRange(0, e?.target?.value?.length)
                            }
                        }}
                        slotProps={{
                            input: {
                                readOnly: true,
                                startAdornment: renderInputStartAdornment(showStartAdornment, startAdornmentText)
                            }
                        }}
                    />
                </Box>
                <Box mt={compact ? 0 : 1.2} ml={1}>
                    <Button type="button" color="primary" onClick={handleCopy} sx={compact ? {height: 30, py: 0} : undefined}>Copy</Button>
                    {open &&
                        <Box sx={{
                            width: '100%',
                            '& > * + *': {
                                marginTop: 2,
                            },
                        }}>
                            <Snackbar
                                autoHideDuration={2500}
                                open={open}
                                onClose={() => setOpen(false)}
                                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                sx={{zIndex: 9999}}
                            >
                                <Alert onClose={() => setOpen(false)} variant="filled" severity="success">
                                    Copied
                                </Alert>
                            </Snackbar>
                        </Box>
                    }
                </Box>
            </Box>
        </div>
    );
}

export default CopyContentToClipboard;
